/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportAuthSupportTransactions } from '../fn/transactions/export-auth-support-transactions';
import { ExportAuthSupportTransactions$Params } from '../fn/transactions/export-auth-support-transactions';
import { exportStationTransactions } from '../fn/transactions/export-station-transactions';
import { ExportStationTransactions$Params } from '../fn/transactions/export-station-transactions';
import { exportSubscriptionTransactions } from '../fn/transactions/export-subscription-transactions';
import { ExportSubscriptionTransactions$Params } from '../fn/transactions/export-subscription-transactions';
import { exportTransactions } from '../fn/transactions/export-transactions';
import { ExportTransactions$Params } from '../fn/transactions/export-transactions';
import { getTransactionInvoice } from '../fn/transactions/get-transaction-invoice';
import { GetTransactionInvoice$Params } from '../fn/transactions/get-transaction-invoice';
import { getTransactionsOfAuthSupport } from '../fn/transactions/get-transactions-of-auth-support';
import { GetTransactionsOfAuthSupport$Params } from '../fn/transactions/get-transactions-of-auth-support';
import { getTransactionsOfSubscription } from '../fn/transactions/get-transactions-of-subscription';
import { GetTransactionsOfSubscription$Params } from '../fn/transactions/get-transactions-of-subscription';
import { getTransactionsOfUser } from '../fn/transactions/get-transactions-of-user';
import { GetTransactionsOfUser$Params } from '../fn/transactions/get-transactions-of-user';
import { getTransactionsOfVehicle } from '../fn/transactions/get-transactions-of-vehicle';
import { GetTransactionsOfVehicle$Params } from '../fn/transactions/get-transactions-of-vehicle';
import { listStationTransactions$Any } from '../fn/transactions/list-station-transactions-any';
import { ListStationTransactions$Any$Params } from '../fn/transactions/list-station-transactions-any';
import { listStationTransactions$Json } from '../fn/transactions/list-station-transactions-json';
import { ListStationTransactions$Json$Params } from '../fn/transactions/list-station-transactions-json';
import { listTransactions } from '../fn/transactions/list-transactions';
import { ListTransactions$Params } from '../fn/transactions/list-transactions';
import { searchTransactions } from '../fn/transactions/search-transactions';
import { SearchTransactions$Params } from '../fn/transactions/search-transactions';
import { searchTransactionsOfAuthSupports$Any } from '../fn/transactions/search-transactions-of-auth-supports-any';
import { SearchTransactionsOfAuthSupports$Any$Params } from '../fn/transactions/search-transactions-of-auth-supports-any';
import { searchTransactionsOfAuthSupports$Json } from '../fn/transactions/search-transactions-of-auth-supports-json';
import { SearchTransactionsOfAuthSupports$Json$Params } from '../fn/transactions/search-transactions-of-auth-supports-json';
import { searchTransactionsOfSubscription$Any } from '../fn/transactions/search-transactions-of-subscription-any';
import { SearchTransactionsOfSubscription$Any$Params } from '../fn/transactions/search-transactions-of-subscription-any';
import { searchTransactionsOfSubscription$Json } from '../fn/transactions/search-transactions-of-subscription-json';
import { SearchTransactionsOfSubscription$Json$Params } from '../fn/transactions/search-transactions-of-subscription-json';
import { TransactionPagedList } from '../models/transaction-paged-list';


/**
 * All about the transactions
 */
@Injectable({ providedIn: 'root' })
export class TransactionsService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTransactionsOfSubscription()` */
  static readonly GetTransactionsOfSubscriptionPath = '/subscriptions/{uid}/transactions';

  /**
   * Search the transactions of a subscription without filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTransactionsOfSubscription$Response(params: GetTransactionsOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of a subscription without filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTransactionsOfSubscription(params: GetTransactionsOfSubscription$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `searchTransactionsOfSubscription()` */
  static readonly SearchTransactionsOfSubscriptionPath = '/subscriptions/{uid}/transactions/search';

  /**
   * Search the transactions of a subscription with filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionsOfSubscription$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionsOfSubscription$Json$Response(params: SearchTransactionsOfSubscription$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return searchTransactionsOfSubscription$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of a subscription with filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionsOfSubscription$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionsOfSubscription$Json(params: SearchTransactionsOfSubscription$Json$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.searchTransactionsOfSubscription$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /**
   * Search the transactions of a subscription with filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionsOfSubscription$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionsOfSubscription$Any$Response(params: SearchTransactionsOfSubscription$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return searchTransactionsOfSubscription$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of a subscription with filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionsOfSubscription$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionsOfSubscription$Any(params: SearchTransactionsOfSubscription$Any$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.searchTransactionsOfSubscription$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `exportStationTransactions()` */
  static readonly ExportStationTransactionsPath = '/stations/{uid}/transactions/export';

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTransactions$Response(params: ExportStationTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTransactions(params: ExportStationTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionTransactions()` */
  static readonly ExportSubscriptionTransactionsPath = '/subscriptions/{uid}/transactions/export';

  /**
   * Export  the transactions assigned to this subscription.
   *
   * Allows to export the Subscription transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionTransactions$Response(params: ExportSubscriptionTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export  the transactions assigned to this subscription.
   *
   * Allows to export the Subscription transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionTransactions(params: ExportSubscriptionTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `listTransactions()` */
  static readonly ListTransactionsPath = '/transactions';

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTransactions$Response(params?: ListTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return listTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTransactions(params?: ListTransactions$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.listTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `searchTransactions()` */
  static readonly SearchTransactionsPath = '/transactions/search';

  /**
   * Retrieve a list of transactions, with pagination, sort and search.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactions$Response(params?: SearchTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return searchTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of transactions, with pagination, sort and search.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactions(params?: SearchTransactions$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.searchTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `exportTransactions()` */
  static readonly ExportTransactionsPath = '/transactions/export';

  /**
   * Export transactions.
   *
   * Allows to export all the transactions as an XLSX File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTransactions$Response(params: ExportTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export transactions.
   *
   * Allows to export all the transactions as an XLSX File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTransactions(params: ExportTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getTransactionInvoice()` */
  static readonly GetTransactionInvoicePath = '/transactions/{uid}/invoice';

  /**
   * Retrieve a transaction's invoice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionInvoice()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionInvoice$Response(params: GetTransactionInvoice$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getTransactionInvoice(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a transaction's invoice.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionInvoice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionInvoice(params: GetTransactionInvoice$Params, context?: HttpContext): Observable<Blob> {
    return this.getTransactionInvoice$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `listStationTransactions()` */
  static readonly ListStationTransactionsPath = '/stations/{uid}/transactions/search';

  /**
   * Retrieve a station list of transactions, with filter and with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listStationTransactions$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listStationTransactions$Json$Response(params: ListStationTransactions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return listStationTransactions$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a station list of transactions, with filter and with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listStationTransactions$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listStationTransactions$Json(params: ListStationTransactions$Json$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.listStationTransactions$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /**
   * Retrieve a station list of transactions, with filter and with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listStationTransactions$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  listStationTransactions$Any$Response(params: ListStationTransactions$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return listStationTransactions$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a station list of transactions, with filter and with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listStationTransactions$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  listStationTransactions$Any(params: ListStationTransactions$Any$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.listStationTransactions$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `getTransactionsOfUser()` */
  static readonly GetTransactionsOfUserPath = '/users/{uid}/transactions';

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfUser$Response(params: GetTransactionsOfUser$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfUser(params: GetTransactionsOfUser$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `getTransactionsOfAuthSupport()` */
  static readonly GetTransactionsOfAuthSupportPath = '/auth-supports/{uid}/transactions';

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfAuthSupport()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTransactionsOfAuthSupport$Response(params: GetTransactionsOfAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfAuthSupport$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTransactionsOfAuthSupport(params: GetTransactionsOfAuthSupport$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `searchTransactionsOfAuthSupports()` */
  static readonly SearchTransactionsOfAuthSupportsPath = '/auth-supports/{uid}/transactions/search';

  /**
   * Search the transactions of an auth-support with filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionsOfAuthSupports$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionsOfAuthSupports$Json$Response(params: SearchTransactionsOfAuthSupports$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return searchTransactionsOfAuthSupports$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of an auth-support with filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionsOfAuthSupports$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionsOfAuthSupports$Json(params: SearchTransactionsOfAuthSupports$Json$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.searchTransactionsOfAuthSupports$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /**
   * Search the transactions of an auth-support with filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionsOfAuthSupports$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionsOfAuthSupports$Any$Response(params: SearchTransactionsOfAuthSupports$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return searchTransactionsOfAuthSupports$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of an auth-support with filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionsOfAuthSupports$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionsOfAuthSupports$Any(params: SearchTransactionsOfAuthSupports$Any$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.searchTransactionsOfAuthSupports$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `exportAuthSupportTransactions()` */
  static readonly ExportAuthSupportTransactionsPath = '/auth-supports/{uid}/transactions/export';

  /**
   * Export the transactions assigned to this auth support.
   *
   * Allows to export the auth support transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportAuthSupportTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportAuthSupportTransactions$Response(params: ExportAuthSupportTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportAuthSupportTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the transactions assigned to this auth support.
   *
   * Allows to export the auth support transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportAuthSupportTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportAuthSupportTransactions(params: ExportAuthSupportTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportAuthSupportTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getTransactionsOfVehicle()` */
  static readonly GetTransactionsOfVehiclePath = '/vehicles/{uid}/transactions';

  /**
   * List the transactions of a vehicle, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfVehicle$Response(params: GetTransactionsOfVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * List the transactions of a vehicle, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfVehicle(params: GetTransactionsOfVehicle$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

}
